$(document).ready(function(){
    // Mobile menu
	$(".header-menu__toggle").click(function(){
		$(".header-menu").addClass("open");
	});
    $(".header-menu__close").click(function(){
		$(".header-menu").removeClass("open");
	});

    // Animation
    if($('.wow').length > 0){
        wow = new WOW({
            boxClass:     'wow',     
            animateClass: 'animated',
            offset:       30,
            mobile:       false,
            live:         true
        })
        wow.init();
    }

    // Change header on scroll
    $(window).scroll(function(){
        if ($(window).scrollTop() >= 10) {
            $('.header').addClass('header--fixed');
        }
        else {
            $('.header').removeClass('header--fixed');
        }
    });

    // Select
    $('.select').click(function(event) {
        if(!$(this).hasClass('disabled')){
            $('.select').not(this).removeClass('active').find('.select-options').slideUp(50);
            $(this).toggleClass('active');
            $(this).find('.select-options').slideToggle(50);
        }
    });
    $('.select-options__value').click(function() {
        $(this).parents('.select').find('.select-title__value span').html($(this).html());
        if($.trim($(this).data('value'))!=''){
            $(this).parents('.select').find('input').val($(this).data('value'));
        }else{
            $(this).parents('.select').find('input').val($(this).html());
        }
    });
    $(document).click(function(e) {
        if (!$(e.target).is(".select *")) {
            $('.select').removeClass('active');
            $('.select-options').slideUp(50);
        };
    });

    // FAQ accordeon
    $(function () {
        let el = $('.faq-accordeon__caption');
        el.click(function() {
            let checkedElement = $(this).next(),
                visibleElement = $('.faq-accordeon__content:visible');
                
            visibleElement.stop().animate({'height':'toggle'}, 300).parent().removeClass('active');     
            if((checkedElement.is('.faq-accordeon__content')) && (!checkedElement.is(':visible'))) {
                checkedElement.stop().animate({'height':'toggle'}, 300).parent().addClass('active');
                return false;
            }   
            if((checkedElement.is('.faq-accordeon__content')) && (checkedElement.is(':visible'))) {
                return false;
            }
        });
    });

    // Product accordeon
    $(function () {
        let el = $('.product-accordeon__caption');
        el.click(function() {
            let checkedElement = $(this).next(),
                visibleElement = $('.product-accordeon__content:visible');
                
            visibleElement.stop().animate({'height':'toggle'}, 300).parent().removeClass('active');     
            if((checkedElement.is('.product-accordeon__content')) && (!checkedElement.is(':visible'))) {
                checkedElement.stop().animate({'height':'toggle'}, 300).parent().addClass('active');
                return false;
            }   
            if((checkedElement.is('.product-accordeon__content')) && (checkedElement.is(':visible'))) {
                return false;
            }
        });
    });

    // // Change quantity
    // $('.quantity__btn').click(function(event) {
    //     let n = parseInt($(this).parent().find('.quantity__value').val());
    //     if($(this).hasClass('btn_minus')){
    //         n = n - 1;
    //         if(n < 1){n = 1;}
    //     }else{
    //         n = n + 1;
    //     }
    //     $(this).parent().find('.quantity__value').val(n);
    //     return false;
    // });

    // Mainproducts carousel
	if($('.mainproducts__carousel').length > 0){
		$('.mainproducts__carousel').slick({
            //infinite: false,
			autoplay: true,
			arrows: false,
			dots: false,
			slidesToShow: 3,
			accessibility: false,
			autoplaySpeed: 3000,
			//centerMode: true,
			//variableWidth: true,
			responsive: [
			{
				breakpoint: 1280,
				settings: {
					slidesToShow:2,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow:1,
				}
			},
            {
				breakpoint: 576,
				settings: {
                    slidesToShow:1,
                    variableWidth: true
				}
			}]
		});
	}

    // Advantages carousel
	if($('.advantages-carousel').length > 0){
		$('.advantages-carousel').slick({
            //infinite: false,
			autoplay: true,
			arrows: false,
			dots: false,
			slidesToShow: 2,
			accessibility: false,
			autoplaySpeed: 6000,
			//centerMode: true,
			variableWidth: true,
			responsive: [
			{
				breakpoint: 222,
				settings: {
					slidesToShow:2,
				}
			},
			{
				breakpoint: 111,
				settings: {
					slidesToShow:1,
				}
			}]
		});
	}
    $('.advantages-nav__arrow.nav__arrow_prev').click(function(event) {
        $(this).parents('.advantages').find('.advantages-carousel').slick('slickPrev');
    });
    $('.advantages-nav__arrow.nav__arrow_next').click(function(event) {
        $(this).parents('.advantages').find('.advantages-carousel').slick('slickNext');
    });

    // Videos carousel
	if($('.videos-carousel').length > 0){
		$('.videos-carousel').slick({
            //infinite: false,
			autoplay: true,
			arrows: false,
			dots: false,
			slidesToShow: 3,
			accessibility: false,
			autoplaySpeed: 6000,
			//centerMode: true,
			variableWidth: true,
			responsive: [
			{
				breakpoint: 222,
				settings: {
					slidesToShow:2,
				}
			},
			{
				breakpoint: 111,
				settings: {
					slidesToShow:1,
				}
			}]
		});
	}
    $('.videos-nav__arrow.nav__arrow_prev').click(function(event) {
        $(this).parents('.videos').find('.videos-carousel').slick('slickPrev');
    });
    $('.videos-nav__arrow.nav__arrow_next').click(function(event) {
        $(this).parents('.videos').find('.videos-carousel').slick('slickNext');
    });

    // Mainreviews carousel
	if($('.mainreviews-carousel').length > 0){
		$('.mainreviews-carousel').slick({
            //infinite: false,
			//autoplay: true,
			arrows: false,
			dots: false,
			slidesToShow: 1,
			accessibility: false,
			autoplaySpeed: 6000,
			variableWidth: true,
            //speed: 300,
			//centerMode: true,
			responsive: [
			{
				breakpoint: 768,
				settings: {
					variableWidth: false,
                    adaptiveHeight: true
				}
			}]
		});
	}
    $('.mainreviews-nav__arrow.nav__arrow_prev').click(function(event) {
        $(this).parents('.mainreviews').find('.mainreviews-carousel').slick('slickPrev');
    });
    $('.mainreviews-nav__arrow.nav__arrow_next').click(function(event) {
        $(this).parents('.mainreviews').find('.mainreviews-carousel').slick('slickNext');
    });

	// Fancybox
	if($('.fancybox').length > 0){
		$(".fancybox").fancybox({
			loop : false,
			arrows : true,
			buttons : [
				'thumbs',
				'close'
			],
            afterClose: function() {
                $('.marquee__content img').css('max-width', 'auto')
            }
		});
	}

    // Modal thanks Reseller
	function showModalThanks(event){
        event.preventDefault();
        $.fancybox.open({
            src  : "#modal-thanks",
            closeExisting: true,
            baseClass: "dark__bg",
            touch: false,
            transitionEffect: "circular",
        });
        setTimeout(() => {
           $.fancybox.close();
        }, 3000);
    };

  // Search
    $(".header-search__btn").click(function(){
        $(this).toggleClass("active");
        $(".header-search__form").toggleClass("open");
    });
    $(document).click(function(e) {
        if (!$(e.target).is(".header-search *")) {
            $(".header-search__btn").removeClass("active");
            $(".header-search__form").removeClass("open");
        };
    });


  let currentlyPlayingVideo = null;

    const updateMainMedia = (src, isVideo, videoSrc) => {
        const mainImg = document.querySelector('.product__mainimg img');
        const mainVideo = document.querySelector('.product__mainimg video');

        if (isVideo) {
            if (mainImg) {
                mainImg.style.display = 'none'; 
            }
            if (mainVideo) {
                mainVideo.style.display = 'block'; 
                mainVideo.src = videoSrc;
                mainVideo.play();  
            }
        } 
        else {
            if (mainVideo) {
                mainVideo.style.display = 'none';  
                mainVideo.pause();  
                mainVideo.src = '';  
            }
            if (mainImg) {
                mainImg.style.display = 'block'; 
                mainImg.src = src;
            }
        }
    };

    const initialize = () => {
        const firstThumb = document.querySelector('.product__images-item img');
        const firstThumbElement = document.querySelector('.product__images-item');

        if (firstThumbElement) {
            const videoSrc = firstThumbElement.getAttribute('data-video');

            if (videoSrc) {
                updateMainMedia(null, true, videoSrc);
                firstThumbElement.classList.add('active');
                currentlyPlayingVideo = document.querySelector('.product__mainimg video');
            } 
            else if (firstThumb) {
            const firstImageSrc = firstThumb.src;
            const firstThumbElement = document.querySelector('.product__images-item');
            firstThumbElement.classList.add('active');

            const mainImg = document.querySelector('.product__mainimg img');
            const mainVideo = document.querySelector('.product__mainimg video');

            if (mainVideo) {
                mainVideo.style.display = 'none';  
            }
            if (mainImg) {
                mainImg.src = firstImageSrc;
            }
          }
        }

        document.querySelectorAll('.product__images-item').forEach(item => {
            item.addEventListener('click', function() {
                const clickedImg = this.querySelector('img');
                const clickedImgSrc = clickedImg.src;
                const videoSrc = this.getAttribute('data-video');

                if (currentlyPlayingVideo) {
                    currentlyPlayingVideo.pause();
                    currentlyPlayingVideo.src = ''; 
                    currentlyPlayingVideo.style.display = 'none';
                    currentlyPlayingVideo = null;
                }

                if (videoSrc) {
                    updateMainMedia(null, true, videoSrc);
                    currentlyPlayingVideo = document.querySelector('.product__mainimg video');
                } else {
                    updateMainMedia(clickedImgSrc, false, null);
                }

                document.querySelectorAll('.product__images-item').forEach(item => item.classList.remove('active'));
                this.classList.add('active');
            });
        });
    };

    initialize();






  
}); 